import { render, staticRenderFns } from "./infinite-loader.vue?vue&type=template&id=4c684aae&scoped=true"
import script from "./infinite-loader.vue?vue&type=script&lang=js"
export * from "./infinite-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c684aae",
  null
  
)

export default component.exports